import {
  VodapayApi,
  VodapayListener,
  VodapayLoader,
  VODAPAY_CLIENT_NAME,
} from 'components/_global/vodapay';
import ApolloClientOptionsContext from 'contexts/apollo-client-options';
import VodapayContext, {
  defaultVodapayContext,
  Vodapay,
  VodapayEventListener,
} from 'contexts/vodapay';
import { ReactNode, useContext, useEffect, useMemo, useState } from 'react';

const VodapayProvider = ({ children }: { children: ReactNode }) => {
  const { setClientOptions } = useContext(ApolloClientOptionsContext);

  const [vodapay, setVodapay] = useState<Vodapay>(defaultVodapayContext);
  const [vodapayApi, setVodapayApi] = useState<VodapayApi | undefined>(
    undefined
  );
  const [vodapayEventListeners, setVodapayEventListeners] = useState<
    VodapayEventListener[]
  >([]);

  useEffect(() => {
    if (!vodapay.isActive) return;
    setClientOptions(options => ({
      ...options,
      clientName: VODAPAY_CLIENT_NAME,
    }));
  }, [vodapay.isActive, setClientOptions]);

  const value = useMemo(() => ({ vodapay, setVodapayEventListeners }), [
    vodapay,
  ]);

  return (
    <VodapayContext.Provider value={value}>
      <VodapayLoader setVodapay={setVodapay} setVodapayApi={setVodapayApi} />

      {children}

      {!!vodapayApi && (
        <VodapayListener
          api={vodapayApi}
          setVodapay={setVodapay}
          vodapayEventListeners={vodapayEventListeners}
        />
      )}
    </VodapayContext.Provider>
  );
};

export default VodapayProvider;
